import $ from 'jquery';

export const elements = {
    call: '.js-StaticTooltip-Call',
    holder: '.js-StaticTooltip-Holder',
    box: '.js-StaticTooltip-Box',
};

export const onFocus = function () {
    const holder = $(this).parents(elements.holder);
    const box = holder.find(elements.box);
    const leftPosition = box.data('ui-statictooltip-leftposition');

    box.removeClass('fn-hidden').transit({
        x: `${leftPosition}%`,
    }, 0);
};

export const onBlur = function () {
    const holder = $(this).parents(elements.holder);
    const box = holder.find(elements.box);

    box.addClass('fn-hidden');
};

export default {
    init() {
        const focus = onFocus;
        const blur = onBlur;

        $(elements.call).on({ focus, blur });
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/form/static-tooltip.js